import {Store} from "./store.model";

export interface GroupedStore {
    zoneId: number;
    zoneName: string;
    stores: Store[];
}
